var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileBookmarkSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 2C3.25 1.58579 3.58579 1.25 4 1.25H10C10.4142 1.25 10.75 1.58579 10.75 2V10C10.75 10.2766 10.5978 10.5307 10.3539 10.6613C10.11 10.7918 9.81412 10.7775 9.58397 10.624L7 8.90139L4.41603 10.624C4.18588 10.7775 3.88997 10.7918 3.64611 10.6613C3.40224 10.5307 3.25 10.2766 3.25 10V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26235 11.859L3.25 19.8138C3.24749 21.4347 4.55429 22.75 6.16717 22.75H12.9695C13.2271 22.75 13.4741 22.6473 13.6564 22.4645L20.4645 15.6367C20.6473 15.4534 20.75 15.2045 20.75 14.945V4.18162C20.75 2.56253 19.4439 1.25 17.8328 1.25H12V10C12 10.7376 11.594 11.4153 10.9437 11.7633C10.2934 12.1114 9.50431 12.0732 8.8906 11.6641L7 10.4037L5.1094 11.6641C4.55922 12.0309 3.86809 12.0995 3.26235 11.859ZM12.5673 20.7941L18.8043 14.5391H14.0673C13.2389 14.5391 12.5673 15.2106 12.5673 16.0391V20.7941Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBookmarkSolidStandard);
export default __webpack_public_path__ + "static/media/file-bookmark-solid-standard.c8ddb9096317ac836d7a7a8bc3a6b7e7.svg";
export { ForwardRef as ReactComponent };